import React from 'react';

const TopRight2Shape = ({ className }) => {
  return (
    <svg 
      className={className}
      width="161" 
      height="544" 
      viewBox="0 0 161 544" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M31.268 29.4855C-13.3741 159.314 4.71047 245.179 24.3065 333.351C43.9025 421.523 168.391 542.445 168.391 542.445L168.39 182.183L168.149 -106.636L0.627236 -217.498C19.2695 -183.313 62.8717 -62.4251 31.268 29.4855Z" 
      fill="white" 
    />
    </svg>
    
  );
};

export default TopRight2Shape;
